<template>
    <transition name="fade">
        <div class="modify-logistics">
            <div class="fullscreen-loading" v-if="loading">
                <div class="loading-spinner">
                    <div class="spinner"></div>
                    <div class="loading-desc">处理中,请稍候...</div>
                </div>
            </div>
            <div class="modify-logistics-body">
                <div class="pop-title">
                    <div class="title">修改物流信息</div>
                    <Icon type="md-close" @click="close" size="18" class="cursor" />
                </div>
                <div class="pop-body">
                    <div class="tips">
                        <Icon type="ios-information-circle-outline" size="16" />
                        <span>发货信息填写错误时可在订单已发货状态修改物流公司和运单号</span>
                    </div>
                    <div class="form-item">
                        <div class="label">订单编号</div>
                        <div class="value text">{{ order.order_no || '-' }}</div>
                    </div>
                    <div class="form-item">
                        <div class="label">发货时间</div>
                        <div class="value text">{{ delivery.send_time || '-' }}</div>
                    </div>
                    <div class="form-item required">
                        <div class="label">物流公司</div>
                        <div class="value">
                            <Select
                                placeholder="请选择物流公司"
                                v-model="form.logistics_id"
                                filterable
                                @on-change="onLogisticsChange"
                            >
                                <Option
                                    v-for="(item,index) in logistics_company_list"
                                    :key="index"
                                    :value="item.id"
                                >{{ item.name }}</Option>
                            </Select>
                        </div>
                    </div>
                    <div class="form-item required">
                        <div class="label">运单号</div>
                        <div class="value">
                            <Input
                                placeholder="请输入运单号"
                                v-model="form.logistics_no"
                                :maxlength="50"
                            />
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="label">修改备注</div>
                        <div class="value">
                            <Input
                                type="textarea"
                                :rows="3"
                                placeholder="选填，记录修改原因"
                                v-model="form.memo"
                            />
                        </div>
                    </div>
                </div>
                <div class="pop-footer">
                    <div class="btn cancel" :class="{ disabled: loading }" @click="!loading && close()">取消</div>
                    <div class="btn confirm" :class="{ loading, disabled: loading }" @click="onConfirm">
                        <span v-if="loading" class="loading-text">处理中...</span>
                        <span v-else>确认修改</span>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { logisticsCompanyList, shopOrderReviseDelivery } from '@/api/index';

export default {
    name: 'ModifyLogistics',
    props: {
        // 订单对象（需包含 uuid、order_no）
        order: {
            type: Object,
            default: () => ({})
        },
        // 当前要修改的发货记录（包含 id、logistics_id、logistics_no、send_time、memo 等）
        delivery: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            loading: false,
            logistics_company_list: [],
            form: {
                logistics_id: '',
                logistics_no: '',
                memo: ''
            }
        };
    },
    mounted() {
        // 初始化表单
        this.form.logistics_id = this.delivery.logistics_id || '';
        this.form.logistics_no = this.delivery.logistics_no || '';
        this.form.memo = '';
        this.onGetLogisticsCompanyList();
    },
    methods: {
        onLogisticsChange() {
            // 选择后清除之前的提示
        },
        async onGetLogisticsCompanyList() {
            try {
                const { code, msg, data } = await logisticsCompanyList();
                if (code > 0) {
                    this.$layer.msg(msg);
                    return;
                }
                this.logistics_company_list = Array.isArray(data) ? data : [];
            } catch (e) {
                console.log('err-logistics-company-list', e);
                this.$layer.msg(e.msg || '获取物流公司失败');
            }
        },
        validate() {
            if (!this.form.logistics_id) {
                return '请选择物流公司';
            }
            if (!this.form.logistics_no) {
                return '请填写运单号';
            }
            return '';
        },
        async onConfirm() {
            const err = this.validate();
            if (err) {
                this.$layer.msg(err);
                return;
            }
            if (this.loading) return;
            if (!this.delivery.id) {
                this.$layer.msg('发货记录异常');
                return;
            }
            this.loading = true;
            try {
                const param = {
                    uuid: this.order.uuid,
                    delivery_id: this.delivery.id,
                    logistics_id: this.form.logistics_id,
                    logistics_no: this.form.logistics_no,
                    memo: this.form.memo
                };
                const { code, msg } = await shopOrderReviseDelivery(param);
                if (code > 0) {
                    this.$layer.msg(msg);
                    return;
                }
                this.$layer.msg('修改成功~');
                this.$emit('revised', { ...this.delivery, ...param });
                this.close();
            } catch (e) {
                console.log('err-revise-logistics', e);
                this.$layer.msg(e.msg || '修改失败，请稍后重试');
            } finally {
                this.loading = false;
            }
        },
        close() {
            this.$emit('close');
        }
    }
};
</script>

<style lang="scss" scoped>
.modify-logistics {
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 110;
    display: flex;
    align-items: center;
    justify-content: center;

    .fullscreen-loading {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 200;
        background: rgba(0, 0, 0, 0.6);
        display: flex;
        align-items: center;
        justify-content: center;

        .loading-spinner {
            display: flex;
            flex-direction: column;
            align-items: center;
            row-gap: 16px;

            .spinner {
                width: 40px;
                height: 40px;
                border: 3px solid rgba(255, 255, 255, 0.3);
                border-top-color: #fff;
                border-radius: 50%;
                animation: spin 0.8s linear infinite;
            }
            .loading-desc {
                color: #fff;
                font-size: 14px;
            }
        }
    }
    @keyframes spin {
        to { transform: rotate(360deg); }
    }

    .modify-logistics-body {
        width: 560px;
        max-height: 80vh;
        background: #fff;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        .pop-title {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid #e0e0e0;
            padding: 17px 16px 14px 24px;

            .title {
                font-size: 18px;
                color: #0f1115;
                font-weight: bold;
            }
        }

        .pop-body {
            width: 100%;
            padding: 20px 24px;
            display: flex;
            flex-direction: column;
            flex: 1;
            overflow-y: auto;
            row-gap: 18px;

            .tips {
                display: flex;
                align-items: center;
                column-gap: 6px;
                background: #fff7e8;
                color: #d97a07;
                border: 1px solid #ffe1b8;
                border-radius: 4px;
                padding: 8px 12px;
                font-size: 12px;
            }

            .form-item {
                display: flex;
                align-items: flex-start;

                &.required {
                    .label::after {
                        content: '*';
                        color: #ff5967;
                        margin-left: 2px;
                    }
                }

                .label {
                    width: 96px;
                    flex-shrink: 0;
                    color: #333;
                    font-size: 14px;
                    line-height: 32px;
                    text-align: right;
                    padding-right: 8px;
                }
                .value {
                    flex: 1;

                    &.text {
                        color: #666;
                        font-size: 14px;
                        line-height: 32px;
                    }
                }
            }
        }

        .pop-footer {
            width: 100%;
            height: 72px;
            display: flex;
            align-items: center;
            justify-content: center;
            column-gap: 10px;
            border-top: 1px solid #e0e0e0;

            .btn {
                height: 40px;
                padding: 0 32px;
                line-height: 40px;
                border-radius: 4px;
                font-size: 14px;
                font-weight: bold;
                cursor: pointer;
            }
            .cancel {
                border: 1px solid #e3e3e3;
                color: #666;
            }
            .confirm {
                background: #ff5967;
                color: #fff;

                &.loading,
                &.disabled {
                    opacity: 0.6;
                    pointer-events: none;
                }
            }
        }
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
